import { utilHelper } from "../../_helpers";

const relativeUrl = 'api/restaurant'

export const restaurantService = {
    getOptions
}

//getOptions
function getOptions(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}